module.exports = __webpack_public_path__ + "img/gravier_roule_beige.8daf1090.jpg";